import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'; // Import Link
import './Navbar.css';
import stadiumLogo from '../assets/images/Stadium Vertical Capsule.jpg'; // Import the new logo

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const isScrolled = window.scrollY > 10;
      if (isScrolled !== scrolled) {
        setScrolled(isScrolled);
      }
    };

    document.addEventListener('scroll', handleScroll);

    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, [scrolled]);

  const handleNavClick = () => {
    const navbarToggler = document.querySelector('.navbar-toggler');
    const navbarCollapse = document.querySelector('.navbar-collapse');

    if (navbarCollapse.classList.contains('show')) {
      navbarToggler.click();
    }
  };

  return (
    <nav className={`navbar navbar-expand-lg fixed-top ${scrolled ? 'scrolled' : ''}`}>
      <div className="container">
        <Link className="navbar-brand" to="/">
          {' '}
          {/* Use Link for home */}
          <img src={stadiumLogo} alt="Stadium Games Logo" className="navbar-logo me-2" />
          <span className="navbar-text">STADIUM GAMES</span>
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            {/* <li className="nav-item">
              <Link className="nav-link" to="/teams" onClick={handleNavClick}>Teams</Link>
            </li> */}
            <li className="nav-item">
              <a className="nav-link" href="/#news" onClick={handleNavClick}>
                News
              </a>{' '}
              {/* Link to News section */}
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#game" onClick={handleNavClick}>
                The Game
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#features" onClick={handleNavClick}>
                Features
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#about" onClick={handleNavClick}>
                About Us
              </a>{' '}
              {/* Link to About section */}
            </li>
            <li className="nav-item">
              <a className="nav-link" href="/#community" onClick={handleNavClick}>
                Community
              </a>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/faq" onClick={handleNavClick}>
                FAQ
              </Link>{' '}
              {/* Link to FAQ page */}
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/vr-experience" onClick={handleNavClick}>
                VR Experience
              </Link>{' '}
              {/* Link to VR Experience page */}
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                href="https://store.steampowered.com/app/3915060/Stadium/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Steam
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
